import {Component} from '@angular/core';

@Component({
    templateUrl: './online-compare-view-wrapper.component.html',
    styleUrls: ['./online-compare-view-wrapper.component.scss'],
    standalone: false
})
export class OnlineCompareViewWrapperComponent {

}
